import Button from "components/general/buttonv2";
import { useState } from "react";
import styled from "styled-components";

export const StyledHeaderTitle = styled.h2`
  font-size: 3rem;
  line-height: 4.2rem;
  font-weight: 700;
  width: 100%;
  margin-bottom: 4rem;
  text-align: center;
  @media screen and (max-width: 1280px) {
    margin: 0 0 1rem 0;
  }
  @media screen and (max-width: 992px) {
    line-height: 1.5;
    font-size: 2.5rem;
  }
  @media screen and (max-width: 768px) {
    line-height: 1.5;
    font-size: 2rem;
    text-align: center;
  }
`;

export const StyledHeader = styled.div`
  width: 100%;
  padding: 2rem 0;
  position: relative;
  background-color: var(--text-color);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--text-color);
  @media screen and (max-width: 1280px) {
    height: auto;
    padding-bottom: 2rem;
  }
  * {
    color: ${(props) => props["data-dark"] && "var(--text-color)"};
  }
`;
const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
const StyledContainer = styled.div`
  max-width: 1280px;
  width: calc(100% - 4rem);
  display: flex;
  padding: 4rem 0;
  gap: 3rem;
  @media screen and (max-width: 1280px) {
    flex-direction: column;
    padding: 2rem 0;
  }
  h2 {
    font-size: 2rem;
    line-height: 1.3;
  }
  h3 {
    font-size: 1.5rem;
    line-height: 1.3;
  }
  h4 {
    font-size: 1.3rem;
    line-height: 1.3;
  }
`;
const StyledBlock = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const StyledFaq = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
`;
const StyledQuestion = styled.div`
  border-radius: 1rem;
  color: var(--text-color);
  padding: 1rem 2rem;
  font-weight: 700;
  cursor: pointer;
  gap: 1rem;
  display: flex;
  svg {
    height: auto;
    width: 1rem;
    fill: var(--text-color);
  }
  @media screen and (max-width: 768px) {
    text-align: center;
    justify-content: center;
  }
`;
const StyledAnswer = styled.div`
  border-radius: 1rem;
  padding: 1rem 2rem;
  @media screen and (max-width: 768px) {
    text-align: center;
  }
`;
const StyledItem = styled.div`
  width: 100%;
  flex-direction: column;
  display: flex;
  border-radius: 6px;
  background: var(--raised-background-color);
`;

const MinusSvg = () => (
  <svg
    clipRule="evenodd"
    fillRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit="2"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m21 11.75c0-.414-.336-.75-.75-.75h-16.5c-.414 0-.75.336-.75.75s.336.75.75.75h16.5c.414 0 .75-.336.75-.75z"
      fillRule="nonzero"
    />
  </svg>
);

const PlusSvg = () => (
  <svg
    clipRule="evenodd"
    fillRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit="2"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m11 11h-7.25c-.414 0-.75.336-.75.75s.336.75.75.75h7.25v7.25c0 .414.336.75.75.75s.75-.336.75-.75v-7.25h7.25c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-7.25v-7.25c0-.414-.336-.75-.75-.75s-.75.336-.75.75z"
      fillRule="nonzero"
    />
  </svg>
);

const FaqItem = ({ question, answer, hasLink }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <StyledItem>
      <StyledQuestion onClick={() => setExpanded((prev) => !prev)}>
        {expanded ? <MinusSvg /> : <PlusSvg />}
        <div>{question}</div>
      </StyledQuestion>
      {expanded && (
        <StyledAnswer>
          {answer}

          {hasLink && (
            <Button
              style={{ marginTop: "1rem" }}
              to="/services"
              buttonBuddy={true}
              dataAttr="hero-services"
            >
              Supported Services
            </Button>
          )}
        </StyledAnswer>
      )}
    </StyledItem>
  );
};

const BottomContent = () => {
  return (
    <StyledWrapper>
      <StyledContainer>
        <StyledBlock>
          <StyledHeaderTitle>FAQ</StyledHeaderTitle>
          <StyledFaq>
            <FaqItem
              question="How does Redact keep my data safe?"
              answer="Unlike similar services, Redact was built for user privacy and control from the ground up. The application runs locally on your device and connects only between your Redact account, and the platforms you're managing. This way, your data is secure and totally in your control."
            />
            <FaqItem
              question="Why should I redact my social media content?"
              answer="Data brokers, scammers, and large corporations process and sell your data at a rapidly growing rate that was impossible just a few years ago. No one is looking through your old content to 'watch your back' - but with Redact, no one is looking through your old content at all."
            />

            <FaqItem
              question="Does redact collect any personal information?"
              answer="Redact does not collect, store, or monitor any personal data outside of your email address for account creation & billing via our payment processes. We are looking to support privacy-friendly payment methods & will only email you with your consent."
            />

            <FaqItem
              question="What services do you support?"
              answer="You can read a full list of services and features here:"
              hasLink={true}
            />

            <FaqItem
              question="Is Redact safe to use?"
              answer="Redact is a privacy first company. That means we collect as little of your data as possible, and anonomize data related to your account. We ensure that no one - not even Redact - can view any of your content that you manage in the Redact application."
            />
          </StyledFaq>
        </StyledBlock>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default BottomContent;
